// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"SearchFilterForDetailsTab_tooltip__2AYKS","tooltipText":"SearchFilterForDetailsTab_tooltipText__3JLDf"};